const questions = document.querySelectorAll<HTMLElement>(
  "[data-action='toggle-faq']",
);

const findElm = (
  elm: HTMLElement,
): { answer: Element | null; button: Element | null } => {
  const answer = elm.querySelector("[data-role='faq-answer']");
  const button = elm.querySelector("[data-role='indicator']");

  return { answer, button };
};

const hideAll = (clickedElm: HTMLElement) => {
  const { answer, button } = findElm(clickedElm);
  let hasShow = true;

  if (!answer || !button) {
    return;
  }

  if (!answer?.classList.contains("hidden")) {
    hasShow = false;
  }

  questions.forEach((elm) => {
    const { answer, button } = findElm(elm);

    if (!button || !answer) {
      return;
    }

    answer.classList.add("hidden");
    button.innerHTML = "+";
  });

  if (hasShow) {
    answer.classList.remove("hidden");
    button.innerHTML = "–";
  }
};

questions.forEach((item) => {
  item.onclick = (e) => {
    if (e.currentTarget instanceof HTMLElement) hideAll(e.currentTarget);
  };

  item.onkeyup = (e) => {
    if (e.currentTarget instanceof HTMLElement) hideAll(e.currentTarget);
  };
});
